<template>
  <div class="content">
    <!-- 头部start -->

    <crumbs :activeIndex="0" ref="crumbs"></crumbs>

    <!-- 头部end -->
    <!-- 轮播图 start-->
    <div class="carousel">
      <el-carousel indicator-position="outside">
        <el-carousel-item
          v-for="bar in banner"
          :key="bar.id"
          style="height:640px;"
        >
          <div class="carousel">
            <img :src="bar.img" alt />
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>

    <!-- 轮播图 end-->
    <!-- 开放时间start -->
    <div class="exhibition-box min">
      <div class="appointment">
        <div class="appointmentRightClass">
          <router-link :to="{ path: '/booking', query: { selectIndex: 0 } }">
            <div class="appointment-right-calendar">
              <div class="appointment-right-icon">
                <img src="../../static/img/calendar.png" alt />
              </div>
              <div class="appointment-right-text">
                <div class="appointment-right-name">{{ visitList.Title }}</div>
                <div class="appointment-sub-name">{{ visitList.Intr }}</div>
              </div>
            </div>
          </router-link>
        </div>
        <div class="appointmentRightClass">
          <router-link :to="{ path: '/booking', query: { selectIndex: 1 } }">
            <div class="appointment-right-calendar">
              <div class="appointment-right-icon">
                <img src="../../static/img/roadLine.png" alt />
              </div>
              <div class="appointment-right-text">
                <div class="appointment-right-name">{{ vistorList.Title }}</div>
                <div class="appointment-sub-name">{{ vistorList.Intr }}</div>
              </div>
            </div>
          </router-link>
        </div>
        <div class="appointmentLeft">
          <div class="appointment-icon-clock">
            <img src="../../static/img/clock.png" alt />
          </div>
          <div class="appointment-time">
            <div class="appointment-time-title">{{ scissorsList.Title }}</div>
            <div class="appointment-time-sub-title active">
              {{ scissorsList.Intr }}
            </div>
          </div>
          <div class="appointmenttimeright">
            <div class="appointment-time">
              <div class="appointment-time-title">{{ bottleList.Intr }}</div>
              <div class="appointment-time-sub-title">
                {{ bottleList.Title }}
              </div>
            </div>
            <div class="appointment-time">
              <div class="appointment-time-title">{{ hoodList.Intr }}</div>
              <div class="appointment-time-sub-title">{{ hoodList.Title }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 开放时间end -->

    <!-- 近期活动  star t -->
    <div class="recent-content min">
      <div class="recent-left">
        <div class="recent-left-title">
          <div>
            <span class="future-active">
              <span class="future">近期</span> 活动</span
            >
          </div>
          <div class="future-more">
            <router-link
              :to="{ path: '/ActivityConsultation', query: { id: 0 } }"
              tag="span"
              >更多>></router-link
            >
          </div>
        </div>
        <div class="carouselClass">
          <el-carousel
            indicator-position="outside"
            height="530px"
            :autoplay="false"
            arrow="always"
          >
            <el-carousel-item
              v-for="(active, index) in activeList"
              :key="index"
            >
              <div class="recent-box recent-box-left">
                <div class="recent-icon">
                  <router-link
                    :to="{ path: '/activeDetails', query: { id: active.Id } }"
                    tag="span"
                  >
                    <img :src="baseURL + active.Pic" alt />
                  </router-link>
                </div>
                <div class="recent-text">
                  <div class="recent-big-title">{{ active.Title }}</div>
                  <div class="exhibition-time">
                    <div>
                      时间:
                      <span>{{ active.CreateDate }}</span>
                    </div>
                    <div>
                      来源:
                      <span>{{ active.Subtitle }}</span>
                    </div>
                  </div>
                </div>
                <div class="recent">
                  <div class="recent-btn">
                    <router-link
                      :to="{ path: '/activeDetails', query: { id: active.Id } }"
                      tag="span"
                      class="recent-btn-more"
                    >
                      <span>查看详情</span>
                      <img src="../../static/img/right.png" alt />
                    </router-link>
                  </div>
                  <div class="recent-btn-num">
                    <span>{{ index + 1 }}</span>

                    <span>/{{ activeList.length }}</span>
                  </div>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>

      <div class="recent-right">
        <div class="recent-left-title">
          <div>
            <span class="future-active">公告</span>
          </div>

          <div class="future-more">
            <router-link
              :to="{ path: '/ActivityConsultation', query: { id: 2 } }"
              tag="span"
              >更多>></router-link
            >
          </div>
        </div>
        <div class="recent-box" v-for="news in announcementList" :key="news.id">
          <ul>
            <li>
              <div class="recent-b-right">
                <router-link
                  :to="{ path: '/activeDetails', query: { id: news.Id } }"
                  tag="span"
                >
                  <div class="recent-b-right-title">{{ news.Title }}</div>
                  <!--  <div class="recent-b-right-sub">{{news.Intr}}</div> -->
                </router-link>
              </div>
              <div class="recent-b-left">
                <div class="recent-year">
                  <img
                    src="../../static/img/timeing.png"
                    alt=""
                    class="recent-icon-1"
                  />
                  {{
                    news.LastUpdateDate.split("-")
                      .slice(0, 1)
                      .join()
                  }}-<span class="recent-day"
                    >{{
                      news.LastUpdateDate.split("-")
                        .slice(1, 2)
                        .join()
                    }}-{{
                      news.LastUpdateDate.split("-")
                        .slice(2, 3)
                        .join()
                    }}</span
                  >
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="recent-right">
        <div class="recent-left-title">
          <div>
            <span class="future-active">
              <span class="future">新闻</span> 资讯</span
            >
          </div>

          <div class="future-more">
            <router-link
              :to="{ path: '/ActivityConsultation', query: { id: 1 } }"
              tag="span"
              >更多>></router-link
            >
          </div>
        </div>
        <div class="recent-box" v-for="news in newsList" :key="news.id">
          <ul>
            <li>
              <div class="" style="display: flex;">
                <div class="recent-item-icon" style=" margin-right:10px;">
                  <img
                    src="../../static/img/tongzhi.png"
                    style="width:44px; height:44px;"
                    alt=""
                  />
                </div>
                <div>
                  <div class="recent-b-right">
                    <router-link
                      :to="{ path: '/activeDetails', query: { id: news.Id } }"
                      tag="span"
                    >
                      <div class="recent-b-right-title">{{ news.Title }}</div>
                      <!--  <div class="recent-b-right-sub">{{news.Intr}}</div> -->
                    </router-link>
                  </div>
                  <div class="recent-b-left">
                    <div class="recent-year">
                      <img
                        src="../../static/img/timeing.png"
                        alt=""
                        class="recent-icon-1"
                      />{{
                        news.LastUpdateDate.split("-")
                          .slice(0, 1)
                          .join()
                      }}
                      <span class="recent-day"
                        >{{
                          news.LastUpdateDate.split("-")
                            .slice(1, 2)
                            .join()
                        }}-{{
                          news.LastUpdateDate.split("-")
                            .slice(2, 3)
                            .join()
                        }}</span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- 近期活动 end -->
    <div class="party-school min">
      <el-carousel height="150px" :autoplay="true">
        <el-carousel-item v-for="item in imgArr" :key="item">
          <router-link
            :to="{ path: '/ActivityConsultation', query: { id: 3 } }"
            tag="span"
          >
            <div style="height:120px;" class="carousel">
              <img :src="item" />
            </div>
          </router-link>
        </el-carousel-item>
      </el-carousel>
      <!-- <el-carousel  arrow="never" height="120px" :autoplay="true">
    <el-carousel-item v-for="item in partyContent" :key="item" >
        <div style="height:120px;" class="carousel"> <img src="../../static/img/djBanner.png" alt=""></div>
    </el-carousel-item>
  </el-carousel> -->
    </div>
    <!-- 热门 start-->
    <div class="hots-active">
      <div class="hot-active">
        <div class="min hot-items">
          <div class="hot-items-left">
            <div class="recent-left-title" style="margin-bottom: 32px">
              <div>
                <span class="future">热门</span>
                <span class="future-active">展项</span>
              </div>
            </div>
            <div class="hot-items-text" v-html="IntrDescription">
              {{ IntrDescription }}
            </div>

            <router-link
              :to="{ path: '/preview', query: { index: selector, id: coolId } }"
            >
              <div class="hot-items-area">更多展项>></div>
            </router-link>
          </div>
          <div class="hot-items-right">
            <!-- <div>
            <span style="color:#0078FF">{{hallList[activeIndex]}}</span>
          </div>-->
            <div class="hot-items-right-exhibits">
              <div
                class="right-exhibits-item"
                v-for="(hall, index) in hallList"
                :key="hall.id"
                :class="{ active: index == activeIndexs }"
              >
                <div @click.prevent="selectFun(index, hall)">
                  {{ hall.Name }}
                </div>
              </div>
            </div>
            <div class="hot-items-right-lunbo">
              <div
                v-for="(venue, index) in gearedList"
                :key="index"
                @mouseover="hover = index"
                @mouseout="hover = -1"
              >
                <div class="right-lunbo-item">
                  <!--@mouseover="mouseOver" @mouseleave="mouseleave"-->
                  <!-- <router-link :to="{ path:'/details',query:{ id:geared.Id } }" tag="span"> -->
                  <img :src="baseURL + venue.Pic" alt />
                  <!-- </router-link> -->
                  <router-link
                    v-show="index !== hover"
                    :to="{ path: '/details', query: { id: venue.Id } }"
                    tag="span"
                  >
                    <p>{{ venue.Title }}</p>
                  </router-link>
                </div>
                <div class="right-lunbo-items" v-show="index == hover">
                  <span>{{ venue.Title }}</span>
                  <span></span>
                  <span>{{ venue.Intr }}</span>
                  <!-- </router-link> -->
                  <div class="recent-btns">
                    <router-link
                      :to="{ path: '/details', query: { id: venue.Id } }"
                      class="recent-btn-mores"
                    >
                      <p>查看详情</p>
                      <img src="../../static/img/mores.png" alt />
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="min recent-content">
      <div class="recent-right">
        <!-- <div class="recent-left-title">
          <div>
            <span class="future-active">党建工作</span>
          </div>

          <div class="future-more">
            <router-link :to="{ path:'/ActivityConsultation' }" tag="span">更多>></router-link>
          </div>
        </div> -->
        <!-- <div class="recent-box" v-for="news in partyContent" :key="news.id">
          <ul>
            <li>

              <div class="recent-b-right">
                <router-link :to="{ path:'/activeDetails',query:{ id:news.Id } }" tag="span">
                  <div class="recent-b-right-title">{{news.Title}}</div>

                </router-link>
              </div>
                  <div class="recent-b-left">

                <div class="recent-year">{{news.LastUpdateDate.split('-').slice(0,1).join()}}  <span
                  class="recent-day"
                >{{news.LastUpdateDate.split('-').slice(1,2).join()}}-{{news.LastUpdateDate.split('-').slice(2,3).join()}}</span></div>
              </div>

            </li>
          </ul>
        </div> -->
      </div>
    </div>

    <!-- 热门 end-->
    <!-- 新闻资讯start -->

    <!-- 列表 -->
    <!-- </div>
    </div>-->

    <!-- 列表 end -->

    <!-- 新闻资讯end -->
    <!-- 友情链接start -->
    <tab></tab>

    <!-- 友情链接end -->
    <Footer></Footer>
  </div>
</template>

<script>
import crumbs from "@/components/header";
import tab from "@/components/tab.vue";
export default {
  components: {
    crumbs,
    tab
  },
  data() {
    return {
      hover: 0,
      hallList: [],
      activeIndex: "",
      activeIndexs: "",
      imgArr: [
        "http://www.sxszstm.com/images/611599c0092837eb3b486829cf528ffe.jpg",
        "http://www.sxszstm.com/images/9592c2249943328c0755961ddbe4912f.jpg",
        "http://www.sxszstm.com/images/246058b2113a96331bed2f594f2588f1.jpg"
      ],
      banner: [
        { img: "http://www.sxszstm.com/images/banner1.jpg" },
        { img: "http://www.sxszstm.com/images/banner2.jpg" },
        { img: "http://www.sxszstm.com/images/banner3.jpg" }
        // { img: "../../static/img/shetuwang.png" }
      ],
      arrList: [],
      newsList: [],
      activeList: [],
      announcementList: [], // 公告
      baseURL: window.SITE_CONFIG.baseUrl + "/yxht",
      gearedList: [],
      // network: [],//暂弃
      bannerList: [],
      scissorsList: {},
      hoodList: {},
      bottleList: {},
      visitList: {},
      vistorList: {},
      hotList: [],
      Status: "",
      venueList: [],
      IntrDescription: "",
      selector: 0,
      gearedLists: {},
      coolId: "",
      partyContent: ""
    };
  },
  created() {
    // this.goodList()
    // this.barList()
    this.selectFun(0);
    this.newList();
    this.active();
    let id = "52886f46-de3e-430f-91a8-12e552631a7c";
    this.scissorsFun();
    this.visitFun();
    this.hotFun();
    this.bannerFun();
    let index = 0;
    this.venueFun(index);
    this.hallListFun();
    this.firstFun();
    this.announcemenFun();
    this.activeConsultation();
  },
  methods: {
    hallListFun() {
      this.$http
        .get("/yxht//Categories/GetList", {
          ParentId: "424bcc2b-4fbf-4a89-9579-0f442bc54010",
          Type: 2,
          rows: 3,
          page: 1
        })
        .then(res => {
          this.hallList = res.data.rows; //热门展项
        });
    },
    bannerFun() {
      this.$http
        .get("yxht//ModuleConfig/LoadPage", {
          channel: "HomeBanner",
          rows: 20,
          page: 1,
          sord: "asc"
        })
        .then(res => {
          // this.banner = res.data.rows; //热门展项
        });
    },
    hotFun() {
      this.$http
        .get("yxapi//api/News/GetNewsList", {
          CategoryId: "832e5291-62da-41a3-b8c1-2dadef8761a8",
          page: 1,
          size: 3
        })
        .then(res => {
          this.geared = JSON.parse(res.data.Result);
          this.hotList = this.geared.rows; //热门展项
        });
    },
    visitFun() {
      this.$http
        .get("yxapi//api/News/GetNewsList", {
          CategoryId: "90ccb7d9-09f3-4f7e-b1cb-575f93a1a4db",
          page: 1,
          size: 3
        })
        .then(res => {
          this.geared = JSON.parse(res.data.Result);
          this.visitList = this.geared.rows[1]; //参观1
          this.vistorList = this.geared.rows[0]; //参观2
          console.log(9999, this.visitList);
        });
    },
    scissorsFun() {
      this.$http
        .get("yxapi//api/News/GetNewsList", {
          CategoryId: "36746161-02c7-4f9f-a1e6-7e40eaac61c2",
          page: 1,
          size: 3
        })
        .then(res => {
          this.geared = JSON.parse(res.data.Result);
          this.scissorsList = this.geared.rows[0]; //开放时间
          this.hoodList = this.geared.rows[1]; //闭馆时间
          this.bottleList = this.geared.rows[2]; //开馆时间
        });
    },
    firstFun() {
      this.$http
        .get("yxht//News/GetNewsList", {
          CategoryId: "e799b3c0-861b-4c75-99b9-660686529023",
          page: 1,
          size: 3
        })
        .then(res => {
          console.log(res, 611);
          console.log(res.data.rows.length, 611);
          this.IntrDescription = res.data.rows[
            res.data.rows.length - 1
          ].Description.replace(
            /\<img src="/gi,
            '<img style="margin:0 auto" src="http://www.sxszstm.com'
          );
          this.gearedList = res.data.rows.slice(0, 3);
        });
    },
    secondSingleFun() {
      this.$http
        .get("yxht//News/GetNewsList", {
          CategoryId: "57eefcfb-4641-401b-b19e-d51e8ddfa7a4",
          page: 1,
          size: 3
        })
        .then(res => {
          console.log(res, 611);
          this.IntrDescription = res.data.rows[
            res.data.rows.length - 1
          ].Description.replace(
            /\<img src="/gi,
            '<img style="margin:0 auto" src="http://www.sxszstm.com'
          );
          this.gearedList = res.data.rows.slice(0, 3);
        });
    },
    thirdFun() {
      this.$http
        .get("yxht//News/GetNewsList", {
          CategoryId: "453d5811-5f61-444e-8e0f-f1436a548c5c",
          page: 1,
          size: 3
        })
        .then(res => {
          console.log(res, 611);
          this.IntrDescription = res.data.rows[
            res.data.rows.length - 1
          ].Description.replace(
            /\<img src="/gi,
            '<img style="margin:0 auto" src="http://www.sxszstm.com'
          );
          this.gearedList = res.data.rows.slice(0, 3);
        });
    },
    selectFun(index, hall) {
      if (index == 0) {
        this.firstFun(index);
      } else if (index == 1) {
        this.secondSingleFun();
      } else if (index == 2) {
        this.thirdFun();
      }
      this.activeIndexs = index;
      this.selector = index;
    },
    venueFun(index) {
      this.coolId = "52886f46-de3e-430f-91a8-12e552631a7c";
      this.$http
        .get("yxapi//api/News/GetNewsList", {
          CategoryId: "52886f46-de3e-430f-91a8-12e552631a7c",
          page: 1,
          size: 4
        })
        .then(res => {
          this.geared = JSON.parse(res.data.Result);
          this.venueList = this.geared.rows;
          // this.Intr = this.geared.rows[index].Intr;
          let gearedLists = this.geared.rows.shift(); //.shift()
          // console.log(this.Intr,113)
          this.gearedList = this.geared.rows;
        });
    },
    secondFun(index) {
      this.coolId = "bc838045-c9cb-4d16-84d4-ade7d7ce101a";
      this.$http
        .get("yxapi//api/News/GetNewsList", {
          CategoryId: "bc838045-c9cb-4d16-84d4-ade7d7ce101a",
          page: 1,
          size: 4
        })
        .then(res => {
          this.geared = JSON.parse(res.data.Result);
          this.venueList = this.geared.rows;
          // this.Intr = this.geared.rows[0].Intr;
          let gearedLists = this.geared.rows.shift(); //.shift()
          // console.log(this.Intr,113)
          this.gearedList = this.geared.rows;
        });
    },
    threeFun(index) {
      this.coolId = "e3565d43-53aa-4278-9f61-9d6c792ff6fd";
      this.$http
        .get("yxapi//api/News/GetNewsList", {
          CategoryId: "e3565d43-53aa-4278-9f61-9d6c792ff6fd",
          page: 1,
          size: 4
        })
        .then(res => {
          this.geared = JSON.parse(res.data.Result);
          this.venueList = this.geared.rows;
          // this.Intr = this.geared.rows[0].Intr;
          // this.Intr = this.geared.rows[0].Intr;
          let gearedLists = this.geared.rows.shift(); //.shift()
          // console.log(this.Intr,113)
          this.gearedList = this.geared.rows;
        });
    },
    gearedFun(id) {
      this.$http
        .get("yxapi//api/News/GetNewsList", {
          CategoryId: id,
          page: 1,
          size: 4
        })
        .then(res => {
          this.geared = JSON.parse(res.data.Result);
          // this.Intr = this.geared.rows[0].Intr;
          let gearedLists = this.geared.rows.shift(); //.shift()
          // console.log(this.Intr,113)
          this.gearedList = this.geared.rows;
        });
    },
    barList() {
      this.$http
        .get("yxapi//api/News/GetCategoriesList", { ParentId: "" })
        .then(res => {
          this.arrList = JSON.parse(res.data.Result);
          this.$nextTick(() => {
            this.$refs.crumbs.arrListFun(this.arrList);
            console.log("this.arrList", this.arrList);
          });
        });
    },
    // 新闻
    newList() {
      this.$http
        .get("yxapi/api/News/GetNewsListNew", {
          CategoryId: "5eb73fde-b433-49f7-9720-58e177d8f855",
          page: 1,
          size: 5
        })
        .then(res => {
          this.news = JSON.parse(res.data.Result);
          this.newsList = this.news.rows;
        });
    },

    // 近期活动
    active() {
      this.$http
        .get("yxapi/api/News/GetNewsList", {
          CategoryId: "71353fc1-044b-42e4-a774-580e52d4fd6d",
          page: 1,
          size: 5
        })
        .then(res => {
          this.active = JSON.parse(res.data.Result);
          this.activeList = this.active.rows;
        });
    },
    activeConsultation() {
      this.$http
        .get("yxapi/api/News/GetNewsList", {
          CategoryId: "c2b21904-2977-49dc-be4a-9ec758b65f89",
          page: 1,
          size: 5
        })
        .then(res => {
          var date = JSON.parse(res.data.Result);
          console.log("222", date);
          this.partyContent = date.rows;
        });
    },
    // c2b21904-2977-49dc-be4a-9ec758b65f89
    // fb26c538-8d1e-4808-80f6-9f1a1476b8d7
    // 公告
    announcemenFun() {
      this.$http
        .get("yxapi/api/News/GetNewsList", {
          CategoryId: "fb26c538-8d1e-4808-80f6-9f1a1476b8d7",
          page: 1,
          size: 5
        })
        .then(res => {
          this.active = JSON.parse(res.data.Result);
          this.announcementList = this.active.rows;
        });
    }
  }
};
</script>

<style scoped>
.party-school {
  height: 120px;
}
.recent-icon-1 {
  width: 18px;
  height: 18px;
  display: inline-block;
  vertical-align: middle;
  margin-right: 7px;
}
.header {
  width: 100%;
  height: 80px;
  background: #ffffff;
  box-shadow: 0px 0px 6px 0px rgba(0, 4, 11, 0.3);
}
.header-list {
  height: 100%;
  display: flex;
  align-items: center;
}
.header-left {
  /* width: 256px; */
  display: flex;
  align-items: center;
}
.header-left .header-icon {
  width: 64px;
  height: 42px;
}
.header-left .header-icon img {
  width: 100%;
}
.header-left .header-left-item {
  margin-left: 7px;
}
.header-left .header-title {
  font-size: 22px;
  letter-spacing: 8px;
  text-align: center;
}

.header-left .header-sub-Title {
  font-size: 12px;
}
.recent {
  padding-bottom: 24px;
}
.recent-btns {
  width: 108px;
  height: 38px;
  line-height: 38px;
  text-align: center;
  border: 1px solid #cdcfd3;
  border-radius: 5px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
  border: 1px solid #cdcfd3;

  margin: 0 auto;
  margin-top: 3px;
}
.recent-btn-more {
  display: flex;
  justify-content: center;
  align-items: center;
}
.recent-btn-more img {
  width: 14px;
  height: 14px;
  margin-left: 5px;
  margin-top: 5px;
}
.recent-btn-mores {
  display: flex;
  justify-content: center;
  align-items: center;
}
.recent-btn-mores p {
  width: 66px !important;
  color: #fff;
}
.recent-btn-mores img {
  width: 14px;
  height: 14px;
  margin-left: 5px;
  margin-top: 5px;
}
.header-right {
  margin-left: 235px;
}
.header-right ul {
  display: flex;
}
.header-right ul li {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
  margin-left: 28px;
}
.header-right ul li.active {
  color: #0078ff !important;
}
.header-login {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
}
.header-account {
  width: 14px;
  height: 14px;
  display: inline-block;
}

/* 轮播图 */
.carousel {
  width: 100%;
  height: 640px;
}
.carousel img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.exhibition-box {
  position: relative;
  margin-top: -73px;
  z-index: 10000000;
}
.exhibition-box .appointment {
  display: flex;
  height: 140px;
  /* background: #ffffff; */
  /* box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.1); */
  border-radius: 10px;
  justify-content: space-between;
}
.exhibition-box .appointment .appointmentLeft {
  display: flex;
  height: 140px;
  width: 31%;
  align-items: center;
  background: linear-gradient(0deg, #dbecff, #ffffff);
  box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
}
.appointment-time-sub-title {
  background: #f2f2f8;
  border-radius: 5px;
  padding: 2px;
  font-size: 12px;
}
.appointment-time-sub-title {
  text-align: center;
}
.active {
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #0078ff !important;
}
/*  开放时间 */
.appointment-icon-clock {
  width: 64px;
  height: 64px;
  margin: 14px;
}
.appointment-icon-clock img {
  width: 100%;
  height: 100%;
}
.appointmenttimeright {
  display: flex;
  padding-left: 15px;
}

.appointmenttimeright .appointment-time {
  margin-right: 10px;
}
.appointment-time-title {
  margin-bottom: 18px;
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
  background: #f2f2f8;
  border-radius: 5px;
  padding: 2px;
  text-align: center;
}
/*  开放时间， 团体预约*/
.appointmentRightClass {
  /* padding-right: 75px; */
  width: 31.3%;
  height: 140px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(0deg, #dbecff, #ffffff);
  box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
}
.appointmentRightClass a {
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  border-left: 1px dashed #e9ebf0;
}

.appointment-right-calendar {
  width: 171px;
  margin: 0 auto;
  display: flex;
  align-items: center;
}
.appointment-right-calendar .appointment-right-icon {
  width: 64px;
  height: 64px;
  margin-right: 11px;
}
.appointment-right-calendar .appointment-right-icon img {
  width: 100%;
}
.appointment-right-text .appointment-right-name {
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
}
.appointment-right-text .appointment-sub-name {
  width: 96px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2; /* 设置行数 */
  -webkit-box-orient: vertical;
}

/* 近期活动 */
.recent-content {
  display: flex;
  justify-content: space-between;
  margin-top: 60px;
  background-image: url(../../static/img/bgInd.png);
  background-size: 78% 90%;
  background-repeat: no-repeat;
  background-position: 134% 32%;
}
.recent-left {
  width: 32%;
  /* margin-right: 3%; */
}
.carouselClass {
  padding: 0 10px;
}
.recent-right {
  width: 32%;
}
.recent-left-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 22px;
  padding: 0 10px;
}
.recent-icon {
  width: 580px;
  height: 302px;
}
.recent-icon img {
  /* width: 100%; */
  height: 90%;
  /* object-fit: cover; */
}
.recent-left-title .future {
  font-size: 24px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #0078ff;
}
.recent-left-title .future-active {
  font-size: 24px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #000000;
}
.recent-text {
  padding-left: 30px;
}
.recent {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.recent-btn {
  width: 108px;
  height: 38px;
  line-height: 38px;
  text-align: center;
  border: 1px solid #cdcfd3;
  border-radius: 5px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
  border: 1px solid #cdcfd3;
  margin-top: 15px;
  margin-left: 30px;
}
.recent-btn:active {
  border: 1px solid #0078ff;
  color: #0078ff;
}
.recent-btn-num {
  position: fixed;
  right: 25px;
}

.recent-btn-num span:nth-child(1) {
  color: #0078ff;
  font-size: 36px;
}
.recent-btn-num span:nth-child(2) {
  color: #333;
  font-size: 24px;
}

.future-more {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
}
.future-more:active {
  color: #0078ff;
}
.recent-big-title {
  height: 69px;
  line-height: 35px;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.exhibition-time {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
  line-height: 34px;
}
.recent-box {
  /* padding: 0 10px; */
}
.recent-box ul li {
  /* border-top: 1px solid #e9ebf0; */
  /* height: 104px; */
  padding: 10px;
  /* display: flex;
  align-items: center; */
}
.recent-box ul li:active {
  background: rgba(0, 120, 255, 0.1);
}
/deep/ .el-carousel__arrow {
  top: 27%;
}
.recent-box .recent-year {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #808080;
  margin-top: 10px;
}

.recent-box .recent-day {
  font-size: 14px;
  font-family: Microsoft YaHei;
  /* font-weight: bold; */
  color: #808080;
}
.recent-b-left {
  /* border-left: 1px solid #cdcfd3; */
  /* padding-left: 10px; */
}
.recent-b-right {
  /* width: 95%; */
  /* padding-left: 30px; */
}

.recent-b-right-title {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
  margin-bottom: 5px;
  /* overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis; */
}
.recent-b-right-sub {
  /* width:80%; */
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  height: 45px;
  color: #666666;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2; /* 设置行数 */
  -webkit-box-orient: vertical;
  word-break: break-all;
}

.recent-box-left {
  background: #f2f2f8;
  /* padding-bottom: 30px; */
}
.hots-active {
  width: 100%;
  height: 515px;
  background-color: #f2f2f8;
}
.hot-active {
  position: relative;
  width: 100%;
  height: 515px;
  background-color: #f2f2f8;
  background: url(/static/img/bg33.0a5a0dc.png) no-repeat;
  background-size: 960px 515px;
  z-index: 100;
}

/* .hot-active:after {
  content: "";
  width: 100%;
  height: 514px;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 10;
  background-color: rgba(242, 242, 248, 0.2);
  background: url("../../static/img/indexbg.png") no-repeat;
  background-size: 100% 100%;
} */
.hot-items {
  display: flex;
  justify-content: space-between;
  padding-top: 60px;
}
.hot-items-text {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
  line-height: 41px;
  width: 370px;
  height: 250px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 6;
  -webkit-box-orient: vertical;
  text-indent: 35px;
}
.hot-items-area {
  font-size: 16px;
  margin-top: 13px;
  color: #666666;
}
.hot-items-right {
}
.hot-items-right-exhibits {
  display: flex;
  justify-content: flex-end;
  /* justify-content: right; */
}
.right-exhibits-item {
  width: 120px;
  height: 40px;
  line-height: 40px;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
  text-align: center;
  margin: 0px 10px;
}
.right-exhibits-item.active {
  width: 120px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  color: #fff !important;
  margin-right: 20px;
  background: #0078ff;
  border-radius: 20px;
}

.hot-items-right-lunbo {
  display: flex;
  margin-top: 33px;
}
.right-lunbo-item {
  width: 239px;
  height: 270px;
  margin-right: 21px;
  /* background: #0078ff; */
}
.right-lunbo-item:hover {
  display: block;
}
.right-lunbo-items {
  display: none;
  width: 239px;
  height: 270px;
  margin-right: 21px;
  display: flex;
  flex-direction: column;
  /* justify-content: center; */
  position: absolute;
  top: 132px;
  background: #0078ff;
  opacity: 0.8;
}
.right-lunbo-items span:nth-child(1) {
  /* width: 239px; */
  text-align: center;
  font-size: 16px;
  color: #fff;
  margin-top: 32px;
  font-size: 600;
}
.right-lunbo-items span:nth-child(2) {
  width: 26px;
  height: 3px;
  margin: 0px auto;
  background: #ff7611;
  margin-top: 15px;
}
.right-lunbo-items span:nth-child(3) {
  width: 174px;
  height: 94px;
  line-height: 33px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  font-size: 16px;
  color: #ffffff;
  text-indent: 32px;
  margin: 16px auto;
}
.right-lunbo-item p {
  font-size: 16px;
  height: 60px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  text-align: center;
  line-height: 60px;
}
.right-lunbo-item img {
  width: 100%;
  height: 270px;
}
.right-lunbo-item span {
  width: 239px;
  height: 60px;
  background: #0078ff;
  position: absolute;
  bottom: 110px;
  opacity: 0.8;
}
.information {
  padding-top: 60px;
}
.information-list {
}
.information-left {
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  /* float: left; */
}

.information-box {
  width: 50%;
  margin-top: 20px;
  overflow: hidden;
}
.information-box:active {
  background: rgba(0, 120, 255, 0.1);
}
.information-box .info-icon {
  width: 180px;
  height: 112px;
  float: left;
  background-color: red;
}
.info-icon img {
  width: 100%;
  height: 100%;
}
.information-box .info-text {
  font-size: 17px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
  line-height: 36px;
  padding-left: 28px;
  width: 358px;
  float: left;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2; /* 设置行数 */
  -webkit-box-orient: vertical;
}

.info-time {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
}
.clear {
  clear: both;
}

.el-carousel__item h3 {
  color: #475669;
  font-size: 18px;
  opacity: 0.75;
  height: 640px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  /* background-color: #99a9bf; */
}

.el-carousel__item:nth-child(2n + 1) {
  /* background-color: #d3dce6; */
}
/* .el-carousel--horizontal {
  height: 640px;
} */
.img-container {
  width: 266px;
  height: 174px;
}
</style>



// WEBPACK FOOTER //
// src/view/index.vue